export default __webpack_public_path__ + "static/device-based-028bf16b0a2cf2b01f8e7c16799d15e9.png";